// src/services/blogApi.js
import api from './api';

const blogApi = {
    // ===== PUBLIC ENDPOINTS =====
    getAllPosts: async () => {
        const res = await api.get('/blog/posts');
        return res.data;
    },

    getPostById: async (id) => {
        const res = await api.get(`/blog/posts/${id}`);
        return res.data;
    },

    // ===== ADMIN ENDPOINTS =====
    createPost: async (postData) => {
        const res = await api.post('/admin/blog/posts', postData);
        return res.data;
    },

    updatePost: async (id, postData) => {
        const res = await api.put(`/admin/blog/posts/${id}`, postData);
        return res.data;
    },

    deletePost: async (id) => {
        await api.delete(`/admin/blog/posts/${id}`);
    },

    togglePublish: async (id) => {
        const res = await api.put(`/admin/blog/posts/${id}/toggle-publish`);
        return res.data;
    },

    // ✅ Upload Slika so progress
    uploadImage: async (file, onProgress = null) => {
        const formData = new FormData();
        formData.append('image', file);
        const res = await api.post('/admin/blog/upload-image', formData, {
            headers: { 'Content-Type': 'multipart/form-data' },
            timeout: 120000,
            onUploadProgress: (progressEvent) => {
                if (onProgress && progressEvent.total) {
                    const percent = Math.round((progressEvent.loaded * 100) / progressEvent.total);
                    onProgress(percent);
                }
            }
        });
        return res.data;
    },

    // ✅ NOVO - Upload Video so progress
    uploadVideo: async (file, onProgress = null) => {
        const formData = new FormData();
        formData.append('video', file);
        const res = await api.post('/admin/blog/upload-video', formData, {
            headers: { 'Content-Type': 'multipart/form-data' },
            timeout: 600000, // 10 minuti za golemi videa
            onUploadProgress: (progressEvent) => {
                if (onProgress && progressEvent.total) {
                    const percent = Math.round((progressEvent.loaded * 100) / progressEvent.total);
                    onProgress(percent);
                }
            }
        });
        return res.data;
    }
};

export default blogApi;